import { useEffect, useState } from "react";
import { SITE } from "@/data/content";

export default function SiteFooter() {
    const [visits, setVisits] = useState(null);

    useEffect(() => {
        const url = `${process.env.REACT_APP_BACKEND_URL}/api/visits`;
        fetch(url, { method: "POST" })
            .then((r) => r.json())
            .then((d) => setVisits(d.count))
            .catch(() => {});
    }, []);

    return (
        <footer className="border-t border-[#E5E1D8]/70">
            <div className="mx-auto flex max-w-4xl flex-wrap items-center justify-between gap-3 px-6 py-8 sm:px-10">
                <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#8C8B88]">
                    © {new Date().getFullYear()} {SITE.name}
                </p>
                <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#8C8B88]">
                    {SITE.location}
                    {visits != null && (
                        <span data-testid="footer-visit-count">
                            {" "}
                            — visitor no. {visits}
                        </span>
                    )}
                </p>
                <a
                    href="#home"
                    data-testid="footer-back-to-top"
                    className="u-link font-mono text-[11px] uppercase tracking-[0.2em] text-[#141413]/60 transition-colors duration-300 hover:text-[#C84B31]"
                >
                    back to top ↑
                </a>
            </div>
        </footer>
    );
}
